import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

const RECENT_BENEFITS = [
  { id: "lounges", icon: "✈️", title: "Airport Lounge", detail: "Ben Gurion — Terminal 3", time: "2 days ago", value: "Complimentary", color: "#6fdc8c" },
  { id: "purchase-protection", icon: "🛡️", title: "Purchase Protection", detail: "Apple MacBook Pro — €2,450", time: "1 week ago", value: "90-day cover", color: "#63b3ed" },
  { id: "stock-back", icon: "📈", title: "Stock-Back Earned", detail: "5% on spend this month", time: "This month", value: "+€87.50", color: "#fbbf24" },
  { id: "esim", icon: "📱", title: "eSIM Data", detail: "3 GB Europe roaming", time: "2 weeks ago", value: "Free", color: "#a78bfa" },
  { id: "car-rental", icon: "🚗", title: "Car Rental Discount", detail: "Hertz Gold — Barcelona", time: "3 weeks ago", value: "30% off", color: "#f97316" },
];

export default function Home() {
  const navigate = useNavigate();
  const [showAll, setShowAll] = useState(false);
  const shown = showAll ? RECENT_BENEFITS : RECENT_BENEFITS.slice(0, 3);

  return (
    <div className="home">
      {/* Header */}
      <header className="mycard-header">
        <button className="mycard-wordmark" aria-label="eToro" type="button" onClick={() => navigate("/promotion")}>
          <span className="wm-e">e</span><span className="wm-toro">Toro</span>
        </button>
        <span className="mycard-title">My Card</span>
        <button className="mycard-avatar" type="button" aria-label="Profile" onClick={() => navigate("/profile")}>YA</button>
      </header>

      {/* Visa Card */}
      <div className="visa-card" onClick={() => navigate("/card")}>
        <div className="visa-card-top">
          <span className="visa-card-brand">eToro</span>
          <span className="visa-card-tier-pill">◆ DIAMOND</span>
        </div>
        <div className="visa-card-chip" />
        <div className="visa-card-number">•••• •••• •••• 4 2 4 2</div>
        <div className="visa-card-bottom">
          <div className="visa-card-holder">
            <span className="visa-card-holder-label">CARD HOLDER</span>
            <span className="visa-card-holder-name">YONI ASSIA</span>
          </div>
          <span className="visa-card-visa">VISA</span>
        </div>
        <div className="visa-card-circle" />
      </div>

      {/* ── BENEFITS NEAR YOU — big card ── */}
      <section className="home-section" style={{ marginTop: 24 }}>
        <button className="nearby-hero-card" type="button" onClick={() => navigate("/nearby")}>
          <img
            src="https://images.unsplash.com/photo-1488646953014-85cb44e25828?auto=format&fit=crop&w=860&h=380&q=85"
            alt="Benefits near you"
            className="nearby-hero-img"
          />
          <div className="nearby-hero-overlay" />
          <div className="nearby-hero-content">
            <div className="nearby-hero-top">
              <span className="nearby-hero-tag">📍 Tel Aviv</span>
              <span className="nearby-hero-count">15 perks nearby</span>
            </div>
            <div className="nearby-hero-bottom">
              <div>
                <span className="nearby-hero-title">Benefits Near You</span>
                <span className="nearby-hero-sub">Hotels, lounges, dining & more</span>
              </div>
              <div className="nearby-hero-arrow">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#050810" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
                </svg>
              </div>
            </div>
          </div>
        </button>
      </section>

      {/* ── RECENT BENEFITS USED ── */}
      <section className="home-section" style={{ marginTop: 20 }}>
        <div className="section-header">
          <span className="section-title">Recent Benefits Used</span>
          <button className="section-action" type="button" onClick={() => setShowAll(v => !v)}>
            {showAll ? "Show less" : "See all"}
          </button>
        </div>

        <div className="recent-list">
          {shown.map(b => (
            <div className="recent-row" key={b.id}>
              <div className="recent-icon" style={{ background: `${b.color}18` }}>
                <span>{b.icon}</span>
              </div>
              <div className="recent-info">
                <span className="recent-title">{b.title}</span>
                <span className="recent-detail">{b.detail}</span>
              </div>
              <div className="recent-right">
                <span className="recent-value" style={{ color: b.color }}>{b.value}</span>
                <span className="recent-time">{b.time}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div style={{ height: 100 }} />
    </div>
  );
}
